var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminalMarkerShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "69px",
    viewBox: "0 0 69 69",
    opacity: 0.2,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TerminalMarker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.1717922,11.400052 C26.2941819,1.27766235 42.7058181,1.27766235 52.8282078,11.400052 C62.9505974,21.5224416 62.9505974,37.9340779 52.8282078,48.0564675 L36.5364675,64.3482078 C35.4117576,65.4729177 33.5882424,65.4729177 32.4635325,64.3482078 L16.1717922,48.0564675 C6.15062649,38.0353018 6.05041483,21.8500454 15.8711573,11.7055979 L16.1717922,11.400052 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.204088438 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TerminalMarker",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FF6366",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalMarkerShape);
export default __webpack_public_path__ + "static/media/TerminalMarkerShape.14d51889a809ad25c740217f19ef751d.svg";
export { ForwardRef as ReactComponent };